//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cookies from 'js-cookie';
import {
  listChannelCurations,
  listChannelPopularElements,
} from '@/api/channels.js';

import { channelCode, freeMediaTypes } from '@motionelements/core/src/helpers/channelTypes.js';
import { getFreeMediaTypeTranslations } from '@/helpers/freeMediaTypes.js';
import { publishedContentCounts, renderContentCount } from '@motionelements/core/src/helpers/contentCount.js';

export default {
  name: 'free-stock-footage',
  scrollToTop: true,
  async asyncData({ params, redirect, store }) {
    const channel = freeMediaTypes.find(({ freeLink }) => freeLink.includes(params.channel));
    if (channel) {
      const channelId = channel.id;
      store.dispatch('channels/setChannelType', channelId);

      return { channelId };
    }
    redirect('/');
  },
  components: {
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
    FreeHero: () => import('@/components/free/FreeHero.vue'),
    FreePartnerCurations: () => import('@/components/free/FreePartnerCurations.vue'),
    FreeCurationsButtons: () => import('@/components/free/FreeCurationsButtons.vue'),
    FreeExplore: () => import('@/components/free/FreeExplore.vue'),
    CustomizeGif: () => import('@/components/channels/CustomizeGif.vue'),
    FreeProducts: () => import('@/components/free/FreeProducts.vue'),
    SubscribeFreeElements: () => import('@/components/free/SubscribeFreeElements.vue'),
    DiscoverMore: () => import('@/components/free/DiscoverMore.vue'),
    StepsToDownload: () => import('@/components/free/StepsToDownload.vue'),
    HomeLicensing: () => import('@/components/home-page/HomeLicensing.vue'),
    HomeFaqs: () => import('@/components/home-page/HomeFaqs.vue'),
    SectionFreeButtons: () => import('@/components/free/SectionFreeButtons.vue'),
  },
  created: function () {
    listChannelPopularElements(this.channelId, {
      perPage: 16,
      free: 1,
    }).then((response) => {
      this.topDownload = response.data.data;
    });

    listChannelCurations(this.channelId, {
      free: 1,
    }).then((response) => {
      const data = response.data.data;
      if (Array.isArray(data)) {
        this.dlpsData = data;
      }
    });
  },
  data() {
    return {
      channelCode,
      topDownload: [],
      dlpsData: [],
      currentCuration: 'top_downloads',
    };
  },
  computed: {
    partnerId() {
      return this.$route.query.partner || cookies.get('ME_partner');
    },
    curationsData() {
      const dlpsData = this.dlpsData
        .map(data => ({
          ...data,
          id: data.heading,
        }))
        .filter(({ items }) => items.data.length);
      return [
        {
          id: 'top_downloads',
          heading: this.$t('term.top_downloads'),
          html: {
            url: this.$link(`/search/${this.channelId}`).param('price_range', '-1').url(),
          },
          items: {
            data: this.topDownload,
          },
        },
        ...dlpsData,
      ];
    },
    pageTitle() {
      // eslint-disable-next-line newline-per-chained-call
      return _.get(getFreeMediaTypeTranslations(this, this.channelId), 'name') || _.upperFirst(this.$term('mediaType', this.channelId).seo().plural().free().text());
    },
    pageDescription() {
      const totalElementCountText = renderContentCount(this, publishedContentCounts.total.element);
      const productText = this.$term('mediaType', this.channelId).plural().text();
      return this.$t('free.meta_description', { product: productText, total_element: totalElementCountText });
    },
    pageOgImage() {
      const languageSuffix = ['en', 'ja', 'ko', 'zh-hant'].includes(this.$i18n.locale) ? this.$i18n.locale : 'en';
      return `https://static.moele.me/img/free/free-elements-og-${languageSuffix}.220830.jpg`;
    },
    breadcrumbList() {
      const freeMediaType = freeMediaTypes.find(({ id }) => id === this.channelId);
      return [
        {
          // eslint-disable-next-line newline-per-chained-call
          name: _.upperFirst(this.$term('mediaType', this.channelId).seo().free().plural().text()),
          link: this.$link(_.get(freeMediaType, 'freeLink')).fullPath(),
          active: true,
        },
      ];
    },
    faqType() {
      if (this.channelId === 'gif') {
        return 'free_gif';
      }
      return this.channelId;
    },
  },
};
